define('controllers/modules/calendar/item/nutrition',[
    // Libs
    'backbone', 'utils',
    // services
    'services/nutrition/entry-tag',
    'services/nutrition/nutrients',
    // parent
    'controllers/modules/calendar/abstract-item',
    // Models
    'models/calendar/item/nutrition',
    // Views | Layout
    'views/modules/calendar/nutrition/nutrition-panel',
], function(
    // libs
    Backbone, U,
    // services
    EntryTagService,
    NutrientService,
    // controller
    AbstractCalendarItemCtrl,
    // Models
    MNutrition,
    // Views | Layout
    VNutritionPanel
) {

    var CalendarNutritionCtrl = AbstractCalendarItemCtrl.extend({

        lazyInit: function() {
            if (!this.view) {
                this.model = new MNutrition();
                this.view = new VNutritionPanel({
                    model: this.model,
                    profile: this.profile,
                    role: this.role,
                    group: this.group,
                    url: this.url.root,
                });
                this.listenTo(this.view, 'back', this.onBack);
            }
            return this.getLayout();
        },

        onFetch: function() {
            return [
                EntryTagService.fetch(),
                NutrientService.fetch()
            ];
        }

    });

    return CalendarNutritionCtrl;

});

